// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e0298f34","843":"29692b69"}[chunkId] + ".chunk.js";
};